
































































































































































































































































































































import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { apiProvider as vozidloProvider } from '@/modules/kartoteka/vozidlo/api';
import { openRouteAndReplace, openEdit, openList } from '@/main/router/routerPath';
import { editFactory, ListLoadBehavior } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';
import { ERROR } from '@/main/store/actionTypes';
import VozidloRidicSelect from '@/modules/servis/zakazka/zakazkovyList/components/VozidloRidicSelect.vue';
import PackageSelect from '@/modules/servis/ozakazka/components/microcomponents/PackageSelect.vue';

import dayJs from 'dayjs';

import moment from 'moment';

import { OrderSubType } from '@/modules/uctenky/fakturace/constants';

import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';

import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import { CustomerVehicleRefresh, ScreenSize, UserRole } from '@/main/components/constants';

import { formatDate } from '@/main/utils/dateFormatter';

import { Row, convertToObjects } from '@/main/utils/table';

import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

import { LAST_ODOMETER } from '@/main/store/constants';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import {
	MIN_FIELD_LEVEL,
	NAME,
	ND,
	PRACOVNI_POZICE,
	STAV,
	ZAKAZKY_ESHOP_LIST,
	ZAKAZKY_LIST,
	TABS,
	TAB_NAMES,
	MERGE_ZAKAZNIK,
	MERGE_VOZIDLO,
	ZAKAZKA_TYP,
	ORDER_STATUS,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PP_PENDING,
	CANCELLATION_REASONS,
	DEPENDENT_TABLES,
	CAMPAIGN_DETAILS,
	PLANNED_ORDER_SERVICE_JOB,
	OrderReports,
	DATE_FORMAT,
	SAVED,
	LOADED,
	PLANNED_ORDER_TO_ORDER_CONVERTED,
} from './constants';
import { store } from './store/edit';
import { editMutations, types } from './store/types';
import OZakazkaZakaznikSelect from './components/microcomponents/ZakaznikSelect.vue';
import OZakazkaVozidloSelect from './components/microcomponents/VozidloSelect.vue';
import ZakladniInformace from './ZakladniInformace.vue';
import Tabs from './components/Tabs.vue';
import { apiProvider as zakazkaProvider } from '../zakazka/api';
import { apiProvider as OZakazkaProvider, apiProvider, ozakazkaReportUrl, apiProvider as apiOzakazka } from './api';
import { NAME as ZAKAZKA, ZAKAZKANDREZ, SERVICE_PKG_PARTS, SERVICE_PKG_LABOR, ZAKAZKA_DRUH, MANDATORY_CAMPAIGN, OPTIONAL_CAMPAIGN } from '../zakazka/constants';
import { OZAKAZKA_ND } from '../constants';
import OzakazkaPendingItems from './components/OzakazkaPendingItems.vue';
import { loggedUser } from '@/main/store/loggedUser';
import { Ozakazka } from '.';


export default editFactory(NAME, store).extend({
	components: {
		VozidloRidicSelect,
		OZakazkaZakaznikSelect,
		OZakazkaVozidloSelect,
		PracovnikSelect: Pracovnik.components.Select,
		Tabs,
		ZakladniInformace,
		PackageSelect,
		DmsPdfDialog,
		OzakazkaPendingItems,
		DropButtons,
	},
	props: {
		filter: { type: Object, default: (): { VozidloId: number | null } => ({ VozidloId: null }) },
	},
	data() {
		return {
			lstOrdersButtons: [
				{
					labelKey: '' as string | null,
					click: '' as string | null,
					param: '' as string | boolean | null,
					disable: '' as string | boolean | null,
					exist: true as boolean | null,
					todo: '' as string | null,
				},
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			firstVisitDialog: {
				visible: false,
				title: null as string | null,
				notificationDialogMsg: null as string | null,
				handleClose: () => { },
			},
			safetyRemarks: {
				visible: false,
				title: null as string | null,
				handleClose: () => { },
			},
			isPreparation: false,
			isNewPlannedOrder: false,
			showDialog: false,
			isOrderSubTypeChecked: false,
			watchlistDialog: false,
			ozakazkaReportUrl,
			dependencies: [
				ND,
				PRACOVNI_POZICE,
				MERGE_ZAKAZNIK,
				MERGE_VOZIDLO,
				ZAKAZKY_LIST,
				ZAKAZKY_ESHOP_LIST,
				SERVICE_PKG_PARTS,
				SERVICE_PKG_LABOR,
				ZAKAZKA_ND_PENDING,
				ZAKAZKA_PP_PENDING,
				DEPENDENT_TABLES,
				CAMPAIGN_DETAILS,
				PLANNED_ORDER_SERVICE_JOB,
			],
			STAV,
			ND,
			PRACOVNI_POZICE,
			PLANNED_ORDER_SERVICE_JOB,
			showChangeDialog: false,
			showCancelOrderDialog: false,
			showDialogCheck: false,
			showDialogConfirmPkg: false,
			showSPDialogConfirmPkg: false,
			changeStateMesssage: '',
			dialogTitle: '',
			checkMessage: '',
			dialogSequence: {
				checkMajitel: false,
				checkOtevreneZak: false,
				checkNoraOtevrene: false,
			},
			stavZakazky: '',
			tiskDialog: {
				visible: false as boolean | null,
				url: null as string | null,
				filter: null as Record<string, any> | null,
				fetchPdfProvider: null as ((filter: {}) => Promise<any>) | null,
				dialogClosed: () => { },
			},
			reportType: '' as string,
			cancellationDialog: false,
			CancellationRemarkInDialog: '' as string | null,
			isCancellationRemarkVisible: false,
			localOrderSubtypeId: null as number | null,
			isMarkAsPrint: false as boolean | null,
			canProceedWithAutoSave: true as boolean,
			plannedOrderDetails: null as any,
			isPlannedOrderDetailsFetched: false as boolean,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(NAME, TABS.Prac)) tabItems.push(TAB_NAMES.PRAC);
			if (this.hasTabAccess(NAME, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(NAME, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(NAME, TABS.Zakazky)) tabItems.push(TAB_NAMES.ZAKAZKY);

			return _.pick(TABS, tabItems);
		},
		getWidth(): string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
		isViewCampaignBtnDisabled(): boolean {
			return this.CancelOrRescheduleStatus === ORDER_STATUS.CANCEL || (this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.ZakazkaDruh !== ZAKAZKA_DRUH.DILENSKA)
			|| this.OrderSubtypeId === OrderSubType.PDI_V || this.isViewMode === true;
		},
		IsOrderType() :boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE;
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
		ozakazakPznText(): string | null | undefined {
			let val;
			this.dropdownList.OzakazkaPzn.forEach((item: any) => {
				if (item.Value === this.OzakazkaPzn) {
					val = item.Text;
				}
			});
			return val;
		},
		isServiceJobVisible(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA;
		},
		allowSave(): boolean {
			return this.rescheduleOrdrPrp === null ? true : this.rescheduleOrdrPrp;
		},
		gdprTiskFilter(): { Id: any; } {
			return {
				Id: this.OzakazkaId,
			};
		},
		noraTableButtons(): object {
			return {
				SELECT_CONFLICT: {
					icon: 'el-icon-plus',
					onClickAction: (e: any, cells: any) => this.addOzakazkaToZakazka(e, cells),
					value: 'SELECT_CONFLICT',
				},
			};
		},
		oZakName(): string | null {
			return this.LocalizePopisPoli('OZAKAZKA_ID');
		},
		isMerged(): boolean {
			return !!(this.ZakaznikId && this.VozidloId);
		},
		mutationsMapper(): Record<string, string> {
			return {
				vozidloRidic: `${this.storeUri}/${types.mutations.VOZIDLO_RIDIC_MAPPER}`,
			};
		},
		mergeError(): string | null {
			if (!this.ZakaznikId) {
				return this.LocalizeChyboveHlasky('PlanZakPrevedZakaznikKon');
			}
			if (!this.VozidloId) {
				return this.LocalizeChyboveHlasky('PlanZakPrevedVozidloKon');
			}

			return null;
		},
		isVozidloChangeForbidden(): boolean {
			return this.VozidloId! > 0 || this.isViewMode;
		},
		isZakaznikChangeForbidden(): boolean {
			return this.ZakaznikId! > 0 || this.isViewMode;
		},
		canCheckMajitel(): boolean | null {
			return ((this.checkMessage === this.LocalizeChyboveHlasky('ZmenitMajiteleVoz')
				|| this.checkMessage === this.LocalizeChyboveHlasky('OtevZakazkaNaVozidlo'))
				&& this.CanEditZakaznik);
		},
		mutationsMappers(): Record<string, string> {
			return {
				vstupPrac: `${this.storeUri}/${editMutations.OZAKAZKA_VSTUP_PRAC_SELECT_MAPPER}`,
			};
		},
		rescheduleOrdrPrp(): boolean | null {
			return this.dmsSys.CancelOrRescheduleOrdrPrp && this.edit.CancelOrRescheduleStatus !== ORDER_STATUS.CANCEL;
		},
		enableGatePass(): boolean {
			return Boolean(this.dmsSys.CancelOrRescheduleOrdrPrp && this.edit.CancelOrRescheduleStatus);
		},
		jobCardPrp(): boolean | null {
			return this.dmsSys.Appointment_2_JobCard_Prp && this.edit.CancelOrRescheduleStatus !== ORDER_STATUS.CANCEL;
		},
		disabledReservation(): boolean | null {
			return this.dmsSys.CancelOrRescheduleOrdrPrp && this.edit.CancelOrRescheduleStatus === ORDER_STATUS.CANCEL;
		},
		disabledElsaPro(): boolean | null {
			return ((this.dmsSys.CancelOrRescheduleOrdrPrp && this.edit.CancelOrRescheduleStatus === ORDER_STATUS.CANCEL) || this.edit.IsOrderPresent || _.isNull(this.ElsaProOrderId));
		},
		campaingDisabled(): boolean {
			return ((this.dependentTables.ZakazkaNd && this.dependentTables.ZakazkaNd.rows.length > 0)
				|| (this.dependentTables.ZakazkaPracovniPozice && this.dependentTables.ZakazkaPracovniPozice.rows.length > 0));
		},
		finalNotificationText(): string | undefined {
			return this.NotificationMessage?.replace('<B>', '')?.replace('</B>', '');
		},
		orderButtons(): object {
			this.lstOrdersButtons = [
				{ labelKey: 'Rezervace', click: 'onRezervacendClick', param: '', disable: this.disabledReservation, exist: !this.dmsSys.AfterSalesPrp, todo: '' },
				{ labelKey: 'cmdSMSEmail', click: '', param: '', disable: true, exist: true, todo: 'TODO' },
				{ labelKey: 'cmdPreparePZ', click: 'openConsentMessage', param: this.STAV.V_PRIPRAVE, disable: false, exist: true, todo: '' },
				{ labelKey: 'cmdRealizePZ', click: '', param: '', disable: true, exist: !this.dmsSys.AfterSalesPrp, todo: 'TODO' },
				{ labelKey: 'cmdNewPZ', click: 'DateCheckNeeded', param: '', disable: false, exist: true, todo: '' },
				{ labelKey: 'btnCancelOrder', click: 'onCancelling', param: '', disable: false, exist: this.rescheduleOrdrPrp, todo: '' },
				{ labelKey: 'btnRescheduleOrder', click: 'onReschduling', param: '', disable: false, exist: this.rescheduleOrdrPrp, todo: '' },
				{ labelKey: 'btnGatePass', click: 'gatePass', param: '', disable: false, exist: this.enableGatePass, todo: '' },
				{ labelKey: 'cmdTrabant', click: '', param: '', disable: true, exist: !this.dmsSys.AfterSalesPrp, todo: 'TODO' },
				{ labelKey: 'cmdPreview', click: 'previewPopUp', param: '', disable: false, exist: this.jobCardPrp, todo: '' },
				{ labelKey: 'Refresh', click: 'getCustomerByGoldenAccountId', param: '', disable: false, exist: true, todo: '' },
			];
			return this.lstOrdersButtons
				.filter((item) => item.labelKey !== undefined && item.labelKey != null && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click, item.param); },
					exist: item.exist,
					disable: item.disable,
					todo: item.todo,
				}));
		},
	},
	created() {
		if (!this.mainCollapse.length) {
			// HlavniUdaje tab is opened by default
			this.mainCollapse = ['HlavniUdaje'];
		}
		this.localOrderSubtypeId = this.OrderSubtypeId === null ? 0 : this.OrderSubtypeId;
		if (this.ContactTypeId && this.CustomerContactDetails) {			
            const selectedDetail = this.CustomerContactDetails.find((detail: any) => detail.ContactTypeId === this.ContactTypeId);
            this.SelectedCustomerContactDetail = selectedDetail || null;
        } else {
			this.SelectedCustomerContactDetail = this.getEmptyContactDetail();			
		}
	},
	watch: {
		OzakazkaNr(val) {
			if (val !== null && val !== 0) {
				this.titleDetail = `${val}`;
			}
		},
		FirstVisitVisible(val) {
			if (val) {
				this.firstVisitDialog.visible = true;
				this.firstVisitDialog.notificationDialogMsg = this.LocalizePopisostatni('CustVisit');
			}
		},
		viewDialogCampaign(newVal, oldVal) {
			if (newVal) {
				if (this.CampaignData.length && !this.isViewCampaignBtnClicked) {
					this.dependentTables.Campaign.rows = [] as Row[];
					this.dependentTables.Campaign.rows = this.CampaignData.map((row: any) => objectToCamelCaseShallow(row)) as Row[];
				}
				this.isViewCampaignBtnClicked = false;
				this.CampaignTable = convertToObjects(this.dependentTables.Campaign) as any[];
				this.mandatoryCampaignCount = this.CampaignTable?.filter(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN)?.length ?? 0;
				if (this.isEditMode && this.OzakazkaId) {
					this.SelectedCampaign = this.CampaignTable?.find(x => x.IsSelected === true)?.ID ?? null;
				}
				if (this.mandatoryCampaignCount === 1) {
					this.SelectedCampaign = this.CampaignTable?.find(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN)?.ID ?? null;
				}
			}
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
		

	},

	methods: {
		async contactTypeChange(value: any) {
            if (value && this.CustomerContactDetails) {
                const selectedDetail = this.CustomerContactDetails.find((detail: any) => detail.ContactTypeId === value);              
				this.SelectedCustomerContactDetail = selectedDetail || null;
            }
        },
		async GetWorkshopOrder() {
			this.startLoading();
			await apiProvider.GetWorkshopOrder(this.OzakazkaId!);
			await this.fetchTableData([ND, PRACOVNI_POZICE]);

			this.endLoading();
		},
		async AssignWorkshopOrder() {
			this.startLoading();
			await apiProvider.AssignWorkshopOrder(this.OzakazkaId!);
			this.endLoading();
		},
		mandatoryCampaignCheckBeforeClose(done: () => void) {
			if (this.mandatoryCampaignCount && (!this.isMandatoryCampaignSelected() || !this.isMandatoryCampaignSaved())) {
				this.showErrorAlert({ message: 'InvalidCampaign' });
			} else {
				done();
			}
		},
		onCampaignRowDeselect(event: Event, row: any) {
			if (row) {
				this.SelectedCampaign = null;
				event.stopPropagation();
			}
		},
		isOptionalCampaignSelected(row: any): boolean {
			return (this.isCampaignSelected(row) && row.CAMPAIGN_CATEGORY === OPTIONAL_CAMPAIGN);
		},
		isCampaignSelected(row: any): boolean {
			return (this.SelectedCampaign === row.ID);
		},
		isSameCampaignSelected(): boolean {
			return this.CampaignTable.some(x => x.IsSelected === true && this.isCampaignSelected(x));
		},
		isMandatoryCampaignSaved(): boolean {
			return this.CampaignTable.some(x => x.IsSelected === true && x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN);
		},
		isMandatoryCampaignSelected() : boolean {
			return !!this.mandatoryCampaignCount && this.CampaignTable.some(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN && this.isCampaignSelected(x));
		},
		call(method:any, args:any) {
			(this as { [key:string]:any })[method](args as any);
		},
		onChangeCancelType(value: any) {
			if (value === CANCELLATION_REASONS.OTHER) {
				this.isCancellationRemarkVisible = true;
			} else {
				this.isCancellationRemarkVisible = false;
			}
		},
		customValidation(): boolean {
			if (this.CancelOrRescheduleStatus === ORDER_STATUS.CANCEL) {
				showAlert({
					message: this.LocalizeChyboveHlasky('CancelledOrderSave'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			return true;
		},
		async saveClick() {
			try {
				this.startLoading();
				const StartTime = performance.now();
				const planDate = new Date(this.ZakazplanDat!);
				const deliveryDate = new Date(this.PozadPredaniDat!);

			if (!this.ContactTypeId) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('RequiredFieldsNotFilled') });
				return;
			}

				if (this.validateDate(deliveryDate) === false) {
					this.canProceedWithAutoSave = false;
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						message: this.LocalizeChyboveHlasky('PROMISED_DATE_IS_INVALID'),
						options: { type: 'error' },
					});
					return;
				}
				if (this.validateDate(planDate) === false) {
					this.canProceedWithAutoSave = false;
					this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							message: this.LocalizeChyboveHlasky('START_DATE_IS_INVALID'),
							options: { type: 'error' },
						});
						return;
				}

				if (this.edit?.EditPracId != null || this.edit?.EditPracId != undefined) {
					const respDeliverySAOnLeave = await OZakazkaProvider.CheckLeave(deliveryDate, this.edit.EditPracId!, this.edit.ProvozovnaId!);
					if (respDeliverySAOnLeave.status === 200 || respDeliverySAOnLeave.status === 201) {
						if (respDeliverySAOnLeave.data === true) {
							this.showErrorAlert({
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								message: this.LocalizeChyboveHlasky('WMS_CHECK_LEAVE_FOR_DELIVERY_SA'),
								options: { type: 'error' },
							});
							return;
						}
					}
				}
				const { data: holidayChecks } = await OZakazkaProvider.CheckHolidayForPlanAndDeliveryDate(this.edit.ProvozovnaId!, planDate, deliveryDate);
				const isResponseValid = holidayChecks !== null && holidayChecks !== undefined;
				if (isResponseValid) {
					if (holidayChecks.Item1 === true) {
						this.canProceedWithAutoSave = false;
						showAlert({
							message: `${this.LocalizeChyboveHlasky('WMS_CHECK_HOLIDAY')}`,
							title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
							options: {
								type: 'error',
							},
						});
						return;
					}
				}

				if (isResponseValid) {
					if (holidayChecks.Item2 === true) {
						this.canProceedWithAutoSave = false;
						showAlert({
							message: `${this.LocalizeChyboveHlasky('WMS_CHECK_HOLIDAY_FOR_DELIVERY_SA')}`,
							title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
							options: {
								type: 'error',
							},
						});
						return;
					}
				}

				if (planDate > deliveryDate) {
					this.canProceedWithAutoSave = false;
					showAlert({
						message: `${this.LocalizeChyboveHlasky('WMS_DELIVERY_DATE_SHOULD_GREATER_THAN_PLAN_DATE_MSG')}`,
						title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
						options: {
							type: 'error',
						},
					});
					return;
				}
				// Parts
				const partsData = convertToObjects(this.dependentTables.NahradniDily).map((polozka, idx) => {
					if (polozka.ZaznamId < 0) {
						polozka.ZaznamId = null;
					}
					return ({ ...polozka, OzakazkaId: this.OzakazkaId });
				});

				let countPart: number = 0;
				partsData.map((item) => {
					if (item.VyrobekndOzn === null || (item.NdNr === null || item.NdNr === '') || item.Text === null
						|| item.Stock === null || item.Stock === '' 
						|| item.Pc === null || item.MnozstviSj === null || item.MnozstviSj <= 0 || _.isNil(item.LocalRrpId) || item.LocalRrpId <= 0) {
						countPart += 1;
					}
				});
				if (countPart > 0) {
					this.canProceedWithAutoSave = false;
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS') });
					return;
				}

				this.edit = {
					...this.edit,
					NahradniDily: partsData,
				};

				// Labor
				const polozky = convertToObjects(this.dependentTables.PracovniPozice).map((polozka, idx) => {
					if (polozka.PpId < 0) {
						polozka.PpId = null;
					}
					return ({ ...polozka, OzakazkaId: this.OzakazkaId });
				});
				let countLabor: number = 0;
				polozky.map((item) => {
					if (item.PracovnikId === null || item.Text === null || item.CasJdnPoc === null || item.StrednaklOzn === null) {
						countLabor += 1;
					}
				});
				if (countLabor > 0) {
					this.canProceedWithAutoSave = false;
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_LABOUR') });
					return;
				}
				this.edit = {
					...this.edit,
					PracovniPozice: polozky,
				};

				const plannedOrderServiceJobData = convertToObjects(this.dependentTables.PlannedOrderServiceJob).map((serviceJob) => {
					if (serviceJob.Id < 0) {
						serviceJob.Id = 0;
						serviceJob.PlannedOrderId = this.OzakazkaId;
					}
					return ({ ...serviceJob, OzakazkaId: this.OzakazkaId });
				});
				this.edit = {
					...this.edit,
					PlannedOrderServiceJobs: plannedOrderServiceJobData,
				};
				this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => plannedOrderServiceJobData.map(data => data.ServiceJobId).includes(x.Value));
				this.ServiceJobs = plannedOrderServiceJobData.map(data => data.ServiceJobId);

				const ManagePlannedOrderOperationsDto = {
					NahradniDily: partsData,
					PracovniPozice: polozky,
					VozidloId: this.edit.VozidloId,
					ProvozovnaId: this.edit.ProvozovnaId,
					OzakazkaId: this.OzakazkaId,
					ServiceJobs: this.ServiceJobs,
					PlannedOrderServiceJobs: plannedOrderServiceJobData,
				};
				await this.save(false);
				await apiProvider.managePlannedOrderOperations(this.OzakazkaId!, ManagePlannedOrderOperationsDto);
			//Call api to save contact details
			await apiProvider.saveCustomerContactDetails(
				{
					orderType: 'PLANNED',
					orderId: this.OzakazkId!,
					vehicleId: this.VozidloId!,
					contactTypeId: this.ContactTypeId!,
					userId: this.loggedUser.PracovnikData.PracovnikId
				});		
				this.canProceedWithAutoSave = true;
				if (this.IsElsaProAutosync && !this.disabledElsaPro) {
				apiProvider.AssignWorkshopOrder(this.OzakazkaId!);
			}
			
				if (this.Memo != null) {
					await apiProvider.UpdateCustomerMemo(this.OzakazkaId!, this.Memo!);
				}
				this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => plannedOrderServiceJobData.map(data => data.ServiceJobId).includes(x.Value));
				await this.refreshTable(ND);
				await this.refreshTable(PRACOVNI_POZICE);
				await this.refreshTable(PLANNED_ORDER_SERVICE_JOB);
				let iTotalTimeTaken = performance.now() - StartTime;
				let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
				await apiProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, SAVED, seconds);
			} finally {
				this.endLoading();
			}
		},
		validateDate(date: Date) {
			if (_.isNil(date)) {
				return false;
			}
			const convertedDate = moment(date.toString()).format(DATE_FORMAT);
			const regex = /^(19|20)\d{2}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/;
			return regex.test(convertedDate);
		},
		async loadData() {
			const startTime = performance.now();
			await this.fetchTableSchemas();
			await this.checkVozidloId();
			if (this.isCreateMode) {
				await this.default();
			} else {
				await this.entity();
				await this.getPartsListDetails();
				this.localOrderSubtypeId = this.OrderSubtypeId === null ? 0 : this.OrderSubtypeId;
				await this.fetchTableData();
				if (this.IsCustomerFirstVisit && this.dmsSys.CustomerFirstPrp) {
					this.FirstVisitVisible = true;
				}
				if (this.IsSafetyRemarks) {
					this.safetyRemarks.visible = true;
				}
				if (this.IsPotentialLead) {
					this.IsPotentialLeadVisible = true;
				}
			}
			await this.loadedData();
			await this.fetchTableData([ZAKAZKA_ND_PENDING, ZAKAZKA_PP_PENDING]);
			if (this.dependentTables.ZakazkaNdPending.rows.length > 0 || this.dependentTables.ZakazkaPracovniPozicePending.rows.length > 0) {
				if (this.dmsSys.WorkItemPrp) {
					this.showDialogConfirmPkg = true;
				}
			}
			this.openRepairRevisit(this.IsCustRevisit);
			this.ifCampaignApplicable();
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, LOADED, seconds);
		},
		async getPartsListDetails() {
			if (!_.isNil(this.OzakazkaId)) {
				const { data: result } = await OZakazkaProvider.getPartsListByPlanOrder('', this.OzakazkaId!, this.VehicleBrand!);
				this.dropdownList.InitialPartsLoadList = result.DropDownList.partsList;
				this.DefaultWarehouseId = result.DefaultWarehouseId;
			}
		},
		ifCampaignApplicable(): void {
			if ((this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA)
			&& (this.isEditMode === true && this.isViewMode === false) && this.OrderSubtypeId !== OrderSubType.PDI_V
			&& this.CancelOrRescheduleStatus !== ORDER_STATUS.CANCEL && this.dependentTables.Campaign && this.dependentTables.Campaign.rows.length > 0) {
				this.isViewCampaignBtnClicked = true;
				this.viewDialogCampaign = true;
			}
		},

		async getCustomerByGoldenAccountId() {
			this.startLoading();
			const { data } = await apiProvider.getCustomerByGoldenAccountId(this.ZakaznikId, this.VozidloIdText, CustomerVehicleRefresh.PLANNEDORDER);
			if (data) {
				this.GetOrderContactDetails(this.OzakazkId!, false);
				this.refreshPage();
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: this.LocalizeChyboveHlasky('DataSyncSuccess'),
					options: { type: 'info' },
				});
			}
			this.endLoading();
		},
		async GetOrderContactDetails(orderId: number, isServiceOrder: boolean) {
			const { data } = await apiProvider.GetOrderContactDetails(orderId, isServiceOrder);
			this.SelectedCustomerContactDetail = data && data.length > 0 ? data[0] : null;
			this.ContactTypeId = this.SelectedCustomerContactDetail ? this.SelectedCustomerContactDetail.ContactTypeId : null;
		},
		async DateCheckNeeded() {
			this.startLoading();
			const { data: DateCheck } = await OZakazkaProvider.IsDateCompareNeeded(this.OzakazkaId!);
			this.endLoading();
			if (DateCheck) {
				this.showErrorAlert({ message: 'DATE_CHECK_PRP_MSG' });
				return;
			}
			this.openConsentMessage(STAV.ZAPLANOVANA);
		},
		openConsentMessage(status: any) {
			if (this.WatchlistFlag && !this.IsWatchlistedRejected) {
				if (status.includes(this.STAV.V_PRIPRAVE)) {
					this.isPreparation = true;
					this.isNewPlannedOrder = false;
				}
				if (status.includes(this.STAV.ZAPLANOVANA)) {
					this.isPreparation = false;
					this.isNewPlannedOrder = true;
				}
				this.watchlistDialog = true;
				return false;
			}
			if (this.WatchlistFlag && this.IsWatchlistedRejected) {
				this.NotificationMessage = null;
				this.NotificationMessage = this.LocalizeChyboveHlasky('RejectWatchlistedOrder');
				this.watchlistDialog = true;
				return false;
			}
			this.openChangeState(status);
			return true;
		},
		checkVozidloId() {
			if (this.filter.VozidloId !== null) {
				this.VozidloId = this.filter.VozidloId;
			}
		},
		openChangeState(stav: string) {
			if (this.WatchlistFlag) {
				this.watchlistDialog = false;
				OZakazkaProvider.sendWatchlistedEmail(this.edit);
			}
			this.stavZakazky = this.isNewPlannedOrder ? this.STAV.ZAPLANOVANA : stav;
			if ([ZAKAZKA_TYP.POPTAVKA_NORA, ZAKAZKA_TYP.ESHOP_SKODA].includes(this.OzakazkaPzn!)) {
				this.changeStateMesssage = this.LocalizeChyboveHlasky('ConfirmO2Zak');
			} else if (this.stavZakazky === this.STAV.V_PRIPRAVE) {
				this.dialogTitle = 'cmdPreparePZ';
				this.changeStateMesssage = this.LocalizeChyboveHlasky('ConfirmPlanZak2Zak');
			} else if (this.stavZakazky === this.STAV.ZAPLANOVANA) {
				this.dialogTitle = 'cmdNewPZ';
				this.changeStateMesssage = this.LocalizeChyboveHlasky('ConfirmPlanZak2ZakFull');
			}
			this.showChangeDialog = true;
		},
		async openRepairRevisit(isRevisitorReRepair: boolean) {
			if (isRevisitorReRepair && this.dmsSys.CustomerRevisitPrp && this.OrderSubtypeId !== OrderSubType.BODY_SHOP) {
				const { data: revisitData } = await zakazkaProvider.getRepeatRepairRevisit(this.VozidloId!, 0);
				const { lastOdomerReading, revisitDate, isRevisit } = objectToCamelCaseShallow(revisitData);
				if (isRevisit) {
					this.IsCustRevisit = true;
					this.showErrorAlert({
						// eslint-disable-next-line max-len
						message: this.LocalizeChyboveHlasky('CarDetailInformation').replace(LAST_ODOMETER, `${lastOdomerReading}`).replace('<LAST_SERVICE>', `${revisitDate}`),
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('infoTitle'),
					});
				}
			}
		},
		createND(OzakazkaId: number | null) {
			openEdit(
				OZAKAZKA_ND,
				PageMode.CREATE,
				{ props: true, filter: { OzakazkaId } },
			);
		},
		async zmenaMajitele() {
			await vozidloProvider.zmenaMajitele({ VozidloId: this.VozidloId, ZakaznikId: this.ZakaznikId });
		},
		async addOzakazkaToZakazka(e: any, cells: any) {
			await zakazkaProvider.mergeWithOzakazka({ zakazkaId: cells.tableNames.ZAKAZKA_ID, ozakazkaId: this.OzakazkaId });
		},
		async clickedCheck() {
			switch (this.checkMessage) {
				case this.LocalizeChyboveHlasky('ZmenitMajiteleVoz'):
					this.showDialogCheck = false;
					await this.zmenaMajitele();
					this.dialogSequence.checkMajitel = true;
					await this.changeState();
					return;
				case this.LocalizeChyboveHlasky('OtevZakazkaNaVozidlo'):
					this.showDialogCheck = false;
					this.dialogSequence.checkOtevreneZak = true;
					await this.changeState();
					return;
				case this.LocalizeChyboveHlasky('EShopJoinOzak2Zak'):
					this.showDialogCheck = false;
					this.dialogSequence.checkNoraOtevrene = true;
					await this.changeState();
					return;
				default:
					this.changeToZakazka();
			}
		},
		async onViewCampaignClick() {
			this.startLoading();
			await this.fetchTableSchemas([CAMPAIGN_DETAILS]);
			await this.fetchTableData([CAMPAIGN_DETAILS]);
			this.endLoading();
			this.ifCampaignApplicable();
		},
		async saveCampaign() {
			if (this.mandatoryCampaignCount && !this.isMandatoryCampaignSelected()) {
				this.showErrorAlert({ message: 'InvalidCampaign' });
				return false;
			}
			if (this.isSameCampaignSelected()) {
				this.viewDialogCampaign = false;
				return false;
			}
			if (this.isEditMode && this.OzakazkaId) {
				this.SelectedCampaign = this.SelectedCampaign || 0;
				try {
					const response = await zakazkaProvider.saveOrUpdateCampaign(0, this.SelectedCampaign, this.OzakazkaId);
					this.viewDialogCampaign = false;
					if (!response.data) {
						this.showErrorAlert({ message: 'ResponseDataNotFoundAlert' });
					} else {
						this.fetchTableData([ND]);
					}
				} catch (error) {
					this.$store.dispatch(ERROR, { error });
				} finally {
					this.viewDialogCampaign = false;
				}
				return false;
			}
			return true;
		},
		async changeState() {
			const startTime = performance.now();
			try {
				this.showChangeDialog = false;
				this.startLoading();
				if (!this.isPlannedOrderDetailsFetched) {
					const { data: plannedOrderDetails } = await apiProvider.GetPlannedOrderDetails(this.ZakaznikId!, this.OrderSubtypeId!, this.OzakazkaId!, this.VozidloId!);
					this.plannedOrderDetails = plannedOrderDetails;
					this.isPlannedOrderDetailsFetched = true;
				}
				const isPlannedOrderConverted = this.plannedOrderDetails?.IsPlannedOrderConverted;
					if (isPlannedOrderConverted) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('serviceOrderExists'),
						});
						return;
					}  
				
				if (this.OrderSubtypeId === 0 || this.OrderSubtypeId === null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('OrderSubTypeRequired'),
						title: this.LocalizeChyboveHlasky('Notification'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				this.showChangeDialog = false;
				const orderSubtypeResult = this.plannedOrderDetails?.OrderSubTypeResult;
				if (this.dmsSys.PDITypePrp === true && !this.isOrderSubTypeChecked) {
					this.isOrderSubTypeChecked = true;
					if (orderSubtypeResult?.length > 0) {
						this.showErrorAlert({
							message: `${this.LocalizeChyboveHlasky('OrderSubTypeAlert')}\n
							${orderSubtypeResult}`,
							localizeMessage: false,
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							options: { type: 'error' },
						});
						return;
					}
				}
				if (!this.dialogSequence.checkMajitel) {
					const customerId = this.plannedOrderDetails?.Customer;
					if (customerId !== this.ZakaznikId) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('VEHICLE_OWNER_CHANGE_CANCEL_APP'),
							localizeMessage: false,
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							options: { type: 'error' },
						});
					} else {
						this.dialogSequence.checkMajitel = true;
						this.changeState();
					}
				} else if (!this.dialogSequence.checkOtevreneZak) {
					const otevreneZak = this.plannedOrderDetails?.PocetOtevrenychZakazek;
					if (otevreneZak > 0) {
						this.checkMessage = this.LocalizeChyboveHlasky('OtevZakazkaNaVozidlo');
						this.showDialogCheck = true;
					} else {
						this.dialogSequence.checkOtevreneZak = true;
						this.changeState();
					}
				} else if (!this.dialogSequence.checkNoraOtevrene) {
					if (this.OzakazkaPzn === ZAKAZKA_TYP.POPTAVKA_NORA && this.dependentTables.eshopZakazkyList.rows.length > 0) {
						this.checkMessage = this.LocalizeChyboveHlasky('EShopJoinOzak2Zak');
						this.showDialogCheck = true;
					} else {
						this.dialogSequence.checkNoraOtevrene = true;
						this.changeState();
					}
				} else if (this.stavZakazky) {
					await this.changeToZakazka();
				}
			} finally {
				this.endLoading();
			}
		},
		async clickAdd(create: any) {
			this.isCreateMode && await this.changeToEdit();

			create(this.OzakazkaId);
		},
		async changeToZakazka() {
			const startTime = performance.now();
			this.startLoading();
			await this.saveClick();
			if (this.canProceedWithAutoSave) {
				const { data: createdZakazkaId } = await this.createZakazka(this.stavZakazky === this.STAV.V_PRIPRAVE);
				// this.ZakazkaId = createdZakazkaId; //commenting this because it is not required and it's opening extra validation popup
				if (createdZakazkaId?.Value === null) {
					this.endLoading();
					return;
				}
				if (this.ServicePackageId! > 0) await this.savePartLaborForZakazka();
				let iTotalTimeTaken = performance.now() - startTime;
				let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
				await apiProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, PLANNED_ORDER_TO_ORDER_CONVERTED, seconds);
				this.endLoading();
				openRouteAndReplace(ZAKAZKA, PageMode.EDIT, { id: createdZakazkaId });
			}
			this.endLoading();
		},
		async savePartLaborForZakazka() {
			await (apiProvider.createParts(this.ZakazkaId!, this.ServicePackageId!, this.VozidloId!));
			await (apiProvider.createLabor(this.ZakazkaId!, this.ServicePackageId!, this.VozidloId!));
		},
		onRezervacendClick() {
			openList(ZAKAZKANDREZ, {
				filter: { OzakazkaId: this.OzakazkaId },
				listLoadBehavior: ListLoadBehavior.HIDE_FILTER,
			});
		},
		async addPackageClick() {
			if (this.ServicePackageId) {
				this.showSPDialogConfirmPkg = true;
				this.fetchTableData([SERVICE_PKG_PARTS, SERVICE_PKG_LABOR]);
			}
		},
		async saveServicePackage() {
			this.showSPDialogConfirmPkg = false;
			this.startLoading();
			await this.save(false);
			this.endLoading();
		},
		async previewPopUp() {
			this.showDialog = true;
		},
		async fetchPdfProvider() {
			return apiOzakazka.getOzakazkaReport(this.OzakazkaId);
		},
		async onCancelling() {
			this.showCancelOrderDialog = false;
			const { data: orderCreatedCount } = await OZakazkaProvider.isOrderCreated(this.OzakazkaId!);
			if (orderCreatedCount > 0) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('OrderIsAlreadyCreated')} :  ${orderCreatedCount}`,
					title: this.LocalizeChyboveHlasky('DMS3_CancelComment'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.CancellationRemarkInDialog = this.CancellationRemarks;
			if (this.CancellationRemarkInDialog !== null && this.OthersType! > 0 && this.CancellationRemarkInDialog?.includes('-')) {
				this.CancellationRemarkInDialog = this.CancellationRemarkInDialog?.split('-')[1].trim();
			}
			this.cancellationDialog = true;
		},

		async validateAndProceedCancellation() {
			if (this.OthersType! === CANCELLATION_REASONS.OTHER && (this.CancellationRemarkInDialog === null
				|| (this.CancellationRemarkInDialog !== null && this.CancellationRemarkInDialog.trim() === ''))) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('CancelRemarks'),
					localizeMessage: false,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
			} else {
				this.CancellationRemarks = this.CancellationRemarkInDialog;
				if (this.OthersType! === CANCELLATION_REASONS.OTHER && (this.CancellationRemarks === null || this.CancellationRemarks === '')) {
					showAlert({
						message: this.LocalizeChyboveHlasky('CancelRemarks'),
						title: this.LocalizeChyboveHlasky('DMS3_CancelComment'),
						options: {
							type: 'info',
						},
					});
				} else {
					// eslint-disable-next-line max-len
					this.CancellationRemarks = `${((this.dropdownList.CancellationReasons.find((item: any) => item.Value === this.OthersType) as any)?.Text)} ${'-'} ${this.CancellationRemarks}`;
					this.showCancelOrderDialog = true;
				}
			}
		},
		async onOkCancelling() {
			this.startLoading();
			this.cancellationDialog = false;
			if (this.CancellationRemarks?.includes('-')) {
				this.CancellationRemarks = this.CancellationRemarks?.split('-')[1].trim();
			}
			await OZakazkaProvider.cancelOrder(0, this.OzakazkaId!, this.Memo!, this.OthersType!, this.CancellationRemarks!);
			this.edit.CancelOrRescheduleStatus = ORDER_STATUS.CANCEL;
			this.showCancelOrderDialog = false;
			this.refreshPreviousPage = true;
			this.endLoading();
			this.closeClick();
		},
		async onReschduling() {
			const planDate = new Date(this.ZakazplanDat!);
			const deliveryDate = new Date(this.PozadPredaniDat!);


			const response = await OZakazkaProvider.CheckHoliday(this.edit.ProvozovnaId!, planDate);
			if (response.status === 200 || response.status === 201) {
				if (response.data === true) {
					showAlert({
						message: `${this.LocalizeChyboveHlasky('WMS_CHECK_HOLIDAY')}`,
						title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
						options: {
							type: 'error',
						},
					});
					return;
				}
			}

			const respForHolidayOnDelivery = await OZakazkaProvider.CheckHoliday(this.edit.ProvozovnaId!, deliveryDate);
			if (respForHolidayOnDelivery.status === 200 || respForHolidayOnDelivery.status === 201) {
				if (respForHolidayOnDelivery.data === true) {
					showAlert({
						message: `${this.LocalizeChyboveHlasky('WMS_CHECK_HOLIDAY_FOR_DELIVERY_SA')}`,
						title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
						options: {
							type: 'error',
						},
					});
					return;
				}
			}

			if (planDate > deliveryDate) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('WMS_DELIVERY_DATE_SHOULD_GREATER_THAN_PLAN_DATE_MSG')}`,
					title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
					options: {
						type: 'error',
					},
				});
				return;
			}

			const { data: createOrderCount } = await OZakazkaProvider.isOrderCreated(this.OzakazkaId!);
			if (createOrderCount > 0) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('OrderIsAlreadyCreated')} : ${createOrderCount}`,
					title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			const hotovoDat = dayJs(this.ZakazplanDat!);

			if (hotovoDat <= dayJs()) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PlanningdateCheck'),
					title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (this.Memo === null || this.Memo === '') {
				showAlert({
					message: this.LocalizeChyboveHlasky('NoteComment'),
					title: this.LocalizeChyboveHlasky('DMS3_ReschComment'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			await this.save(false);
			await (OZakazkaProvider.rescheduleOrder(0, this.OzakazkaId!, this.Memo, planDate, deliveryDate));
			this.enableGatePass = true;
			this.edit.CancelOrRescheduleStatus = ORDER_STATUS.RESCHEDULE;
		},
		async gatePass() {
			const flag = await apiProvider.isVehicleInward(this.OzakazkaId!);
			if (!flag.data) {
				showAlert({
					message: this.LocalizeChyboveHlasky('GatePassVehicleInward'),
					title: this.LocalizeChyboveHlasky('DMS3_GatePassTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.tiskDialog.filter = {
				Id: this.OzakazkaId,
				OrderPOrder: false,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
			};
			this.tiskDialog.fetchPdfProvider = (filter: any) => OZakazkaProvider.getGatePassServisReport(filter);
			this.tiskDialog.visible = true;
		},
		redirectToAppointment() {
			if (this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.SERVICE_ADVISER) {
				window.location.replace(`${this.dmsSys.DMSC_url}/wmsModule/WmsServiceAdvisor/List`);
			} else {
				window.location.replace(`${this.dmsSys.DMSC_url}/wmsModule/WmsReception/List`);
			}
		},
		isCampaignDisabled(row: any): boolean {
			return this.mandatoryCampaignCount > 0 && row.CAMPAIGN_CATEGORY === OPTIONAL_CAMPAIGN;
		},
		onCampaignRowSelection(row: any) {
			if (row) {
				if (!this.isCampaignDisabled(row)) {
					this.SelectedCampaign = row.ID;
				}
			}
		},
		getFormattedDate(date: string): string | null {
			return formatDate(date);
		},
		markReportAsPrinted() {
			apiProvider.markReportAsPrinted(this.ZakazkaId, this.reportType);
		},
		onPreviewClick() {
			if ([OrderReports.ServiceEstimation].includes(this.ReportID! as OrderReports)) {
				this.printReport(this.ReportID!);
			} else {
				this.showReport(this.ReportID!);
			}
		},
		printReport(ReportID: string) {
			this.isMarkAsPrint = true;
			this.tiskDialog.filter = {
				Id: this.OzakazkaId,
				OrderPOrder: true,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
				IsPlannedOrder: true,
			};
			this.tiskDialog.visible = true;
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getReport(filter, ReportID);
		},
		showReport(ReportID: string) {
			this.isMarkAsPrint = true;
			this.tiskDialog.filter = {
				Id: this.OzakazkaId,
				IsPlannedOrder: true,
			};
			this.tiskDialog.visible = true;
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getReport(filter, ReportID);
		},
		 getEmptyContactDetail() {
       		 return {
				Id: 0,
				SfContactId: null,
				Name: null,
				Email: null,
				Phone: null,
				Mobile: null,
				Zip: null,
				City: null,
				Address: null,
				Relationship: null,
				ContactTypeId: 0,
				ContactTypeText: null,
				CustomerId: 0,
				LastModifiedTimeAtSF: '',
				CreatedAt: '',
				UpdatedAt: ''
        };
    },
	},
});
